import "./style/index.css";
import App from "./components/App";

import "./urlparams";

export default App;
